function ez_selectStyler() {

    var select = $('.ez_select select');

    if (select.length) {
        select.styler({
            selectSmartPositioning : false,
            selectSearch           : false
        });
    }

}